module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"tool-title":"Percentiles (2010-2019)","depth-label":"Profondeur [m]","legend-label":"Probabilité de dépassement du seuil sélectionné"},"de":{}}')
  delete Component.options._Ctor
}
